// extracted by mini-css-extract-plugin
export default {"mainNormalItem":"mainwire-scroller_mainNormalItem__xRW8M","headlineViewer":"mainwire-scroller_headlineViewer__BiExh"};